import * as React from 'react';
import '../../Css/Global/Global.css';

import {Grid, Alert, Card, CardContent} from "@mui/material";
import Divergencias from '../Dashboard/Divergencias';
import NenhumSped from '../Dashboard/NenhumSped';
import ProgressoAnalise from '../Dashboard/ProgressoAnalise';
import Competencia from '../Dashboard/Competencia';
import EstablishmentSelector from '../../Components/EstablishmentSelector';


type DivergenciaItem = {
  descricao: string;
  created_at: string;
};

type DivergenciaPorTipo = {
  quantidade: number;
  divergencias: DivergenciaItem[];
};

const DivergenciasPage: React.FC = () => {

    const [loading, setLoading] = React.useState(true);
    const [nenhumSped, setNenhumSped] = React.useState(false);
    const [analisando, setAnalisando] = React.useState(false);
    const [progresso, setProgresso] = React.useState(0);
    const [statusImportacao, setStatusImportacao] = React.useState('');
    const [divergencias, setDivergencias] = React.useState<{ [tipo: string]: DivergenciaPorTipo }>({});
    const [insightLoading, setInsightLoading] = React.useState(false);
    const [insight, setInsight] = React.useState('');

    const [spedFiscalIdSelecionado, setSpedFiscalIdSelecionado] = React.useState<number | null>(null);
    const [establishmentAliasIdSelecionado, setEstablishmentAliasIdSelecionado] = React.useState<string | number>('');

    const handleEstablishmentChange = React.useCallback((aliasId: string | number) => {
        setEstablishmentAliasIdSelecionado(aliasId);
    }, []);

    React.useEffect(() => {
      if (Number(spedFiscalIdSelecionado) > 0){
        const fetchData = async () => {
            try {
              const spedResponse = await fetch(`${process.env.REACT_APP_API_URL}sped-fiscal/ultimo/${spedFiscalIdSelecionado}`);
              const sped = await spedResponse.json();

              if (sped.status === 'Nenhum SPED Fiscal importado ainda') {
                setNenhumSped(true);
              }

              else if (sped.status === 'Realizando importação') {
                  setAnalisando(true);
                  const res = await fetch(`${process.env.REACT_APP_API_URL}sped-fiscal/progresso/${spedFiscalIdSelecionado}`);
                  const data = await res.json();
                  setProgresso(data.progresso);
                  setStatusImportacao(data.status_job);
              }

              else if(sped.status === 'Importação concluída'){
                //checa se já está analisando o EAN
                const resEan = await fetch(`${process.env.REACT_APP_API_URL}divergencias/status-analise-ean/${spedFiscalIdSelecionado}`);
                const dataEan = await resEan.json();

                if(dataEan.has_sped === 0 || dataEan.import_progress === 100){
                  setAnalisando(false);
                }
                else{
                  setAnalisando(true);
                  setProgresso(dataEan.import_progress);
                  setStatusImportacao(dataEan.status_job);
                }
              }

              // Buscar as divergências agrupadas por tipo
              const divergenciasResponse = await fetch(`${process.env.REACT_APP_API_URL}divergencias/agrupadas/${spedFiscalIdSelecionado}`);
              const divergenciasData = await divergenciasResponse.json();
              setDivergencias(divergenciasData);
            } catch (e) {
                console.error('Erro ao carregar dados do dashboard', e);
            } finally {
                setLoading(false);
            }
        };

        const fetchInsight = async () => {
            try {
                setInsight('');
                setInsightLoading(true);
    
                const response = await fetch(`${process.env.REACT_APP_API_URL}divergencias/insights/${spedFiscalIdSelecionado}`);
                const data = await response.json();
    
                setInsight(data.insight || 'Sem insights disponíveis.');
            } catch (error) {
                console.error('Erro ao buscar insights:', error);
                setInsight('Erro ao gerar insights.');
            } finally {
                setInsightLoading(false);
                setAnalisando(false);
            }
        };
        fetchData();
        fetchInsight();
      }
    }, [spedFiscalIdSelecionado]);

    return (
        <>
              {nenhumSped ? (
                <NenhumSped />
              ) : (
                <>
                  <Grid container spacing={0.5}>
                    <Grid item xs={12}>
                        <Grid container spacing={2} justifyContent="flex-end" alignItems="center" wrap="nowrap">
                          <Grid item xs="auto">
                            <EstablishmentSelector disableCard onChangeEstablishment={handleEstablishmentChange} />
                          </Grid>
                          <Grid item xs="auto">
                            <Competencia
                              disableCard
                              key={establishmentAliasIdSelecionado}
                              onChangeSpedFiscalId={(id: number | null) => setSpedFiscalIdSelecionado(id)}
                            />
                          </Grid>
                        </Grid>
                    </Grid>
                    {analisando ? (
                        <ProgressoAnalise
                        progresso={progresso}
                        statusImportacao={statusImportacao}
                      />
                    ) : null}
               
                    <Divergencias
                    insight={insight}
                    insightLoading={insightLoading}
                    divergencias={divergencias}
                    loading={loading}
                  />
                  </Grid>
                </>
                
            )}            
        </>
      );
      
}


export default DivergenciasPage;

